export const BASE_URL = `${process.env.REACT_APP_API_ENDPOINT}/api/session/v1`;
